import React from "react";
import { CollapsePanel } from "./CollapsePanel";

export const StepTherapyInfo = ({ biInfo }) => {
  const stepTherapyInfo = biInfo?.cpt_coverage;

  const stRequiredMessage = (stCovered) => {
    if (stCovered === true) return "Yes";
    if (stCovered === false) return "No";
    return "Unknown";
  };

  return (
    stepTherapyInfo && (
      <div className="mb-2">
        <CollapsePanel labelText="Step Therapy Info">
          <table id="step-therapy-section" className="table table-striped rounded table-borderless">
            <thead>
              <tr>
                <th title="CPT Codes.">Procedure Code</th>
                <th title="Step Therapy Required">Step Therapy Required</th>
                <th title="Step Therapy Details">Step Therapy Details</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(stepTherapyInfo).map(([code, info]) => (
                <tr key={code} className="js-table-row">
                  <td className="cell-data">
                    <h5 className="fw-bold text-start text-dark">{code}</h5>
                  </td>
                  <td className="cell-data">
                    <h5 className="fw-bold text-start text-dark">{stRequiredMessage(info.step_therapy_hash?.covered_st)}</h5>
                  </td>
                  <td className="cell-data">
                    {info.step_therapy_hash?.covered_st && (
                      <h5 className="fw-normal text-start text-dark">{info.step_therapy_hash.st_details || "N/A"}</h5>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CollapsePanel>
      </div>
    )
  );
};
